import { MDBOrganizationChart } from 'mdb-react-organization-chart';
import React from "react";

export default function Org() {
  const myData = {
    name: 'Walter White',
    label: 'CEO',
    avatar: 'https://mdbcdn.b-cdn.net/img/new/avatars/1.webp',
    children: [
      {
        name: 'Jon Snow',
        label: 'CFO',
        avatar: 'https://mdbcdn.b-cdn.net/img/new/avatars/2.webp',
        children: [
          {
            label: 'Analysis',
          },
          {
            label: 'Sales',
          },
        ],
      },
      {
        label: 'CMO',
        name: 'Kim Wexler',
        avatar: 'https://mdbcdn.b-cdn.net/img/new/avatars/9.webp',
        children: [
          {
            label: 'Marketing',
          },
        ],
      },
      {
        label: 'CIO',
        name: 'Phoebe Buffay',
        avatar: 'https://mdbcdn.b-cdn.net/img/new/avatars/5.webp',
        children: [
          {
            label: 'Development',
            name: 'Chandler Bing',
            avatar: 'https://mdbcdn.b-cdn.net/img/new/avatars/3.webp',
            children: [
              {
                label: 'Analysis',
              },
              {
                label: 'Front End',
              },
              {
                label: 'Back End',
              },
            ],
          },
          {
            label: 'QA',
            name: 'Rachel Green',
            avatar: 'https://mdbcdn.b-cdn.net/img/new/avatars/10.webp',
          },
          {
            label: 'R&D',
            name: 'Monica Geller',
            avatar: 'https://mdbcdn.b-cdn.net/img/new/avatars/11.webp',
          },
        ],
      },
    ],
  };

  return <MDBOrganizationChart data={myData} className='m-5 d-flex align-items-center justify-content-center ' />;
}